const EstadosVentaEnum = {
  Vendido: 9,
  Apartado: 10,
}

export default EstadosVentaEnum;
